// Crew-styled invite/edit user modal - Tailwind overlay wrapping existing UserManagement_Form
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ErrorToast } from 'components';
import IdUserService from 'api/identity/user';
import UserService from 'api/user';
import UserManagementForm from '../features/userManagement/UserManagement_Form';

const CrewInviteUserModal = ({
  toggleModal,
  isModalToggled,
  user,
  deptDropOptions,
  fetchUsers,
  match,
  objDepts,
}) => {
  const userInfo = useSelector((state) => state.general.user);
  const [isSaving, setIsSaving] = useState(false);

  const onSubmit = async (payload) => {
    try {
      setIsSaving(true);
      const fPayload = formatData(payload);
      const createdUser = await userApiCall(fPayload);
      await assignDepartment({ userId: createdUser.id || createdUser.user_id, departments: payload.department.filter((n) => n) });
      await fetchUsers();
      if (payload.email === userInfo.email) await getCurrentUser();
      setIsSaving(false);
      toggleModal(false);
    } catch (error) {
      toast.error(<ErrorToast error={error} />);
      setIsSaving(false);
    }
  };

  const getCurrentUser = async () => {
    window.location.reload();
  };

  const userApiCall = async (fPayload) => {
    if (!!user) {
      const { data: { result } } = await updateUser(fPayload);
      return result;
    }
    const { data: { data } } = await inviteUser(fPayload);
    return data;
  };

  const formatData = (payload) => {
    if (payload?.department?.includes(null)) payload.department = [null];
    if (payload.role === 'admin') payload.department = [];
    payload.department = payload.department.filter((n) => n);
    const clientId = match.params.id || localStorage.getItem('ROOT_ID');
    let fData = {
      ...payload,
      username: payload.email,
      metadata: { name: payload.name, role: payload.role, rights: formatRightsData(payload) },
      currentClientId: clientId,
      client_id: clientId,
    };
    if (!!user) {
      fData = { ...user, ...fData, metadata: { ...user.metadata, ...fData.metadata } };
    }
    delete fData.role;
    delete fData.roles;
    delete fData.departments;
    return fData;
  };

  const formatRightsData = (payload) => {
    if (payload.role === 'admin') return {};
    const rights = {};
    payload.department.forEach((deptId) => { rights[deptId] = payload.rights[deptId]; });
    return rights;
  };

  const updateUser = (payload) => IdUserService.updateUser(payload);

  const assignDepartment = (payload) => {
    if (user?.departments?._id) return updateDepartment(user?.departments?._id, payload);
    return UserService.assignDepartment(payload);
  };

  const updateDepartment = (departmentId, payload) => UserService.updateById(departmentId, payload);

  const inviteUser = (payload) => IdUserService.createUser(payload);

  if (!isModalToggled) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center">
      {/* Backdrop */}
      <div className="tw-fixed tw-inset-0 tw-bg-black/50" onClick={() => toggleModal(false)} />

      {/* Card */}
      <div className="tw-relative tw-bg-white tw-rounded-xl tw-shadow-xl tw-w-full tw-max-w-md tw-mx-4 tw-max-h-[85vh] tw-overflow-y-auto">
        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-p-6 tw-border-b tw-border-gray-200">
          <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0">
            {!!user ? 'Edit user' : 'Invite new user'}
          </h2>
          <button
            onClick={() => toggleModal(false)}
            className="tw-p-1 tw-rounded tw-border-0 tw-bg-transparent tw-cursor-pointer hover:tw-bg-gray-100"
          >
            <X className="tw-w-5 tw-h-5 tw-text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <div className="tw-p-6">
          <UserManagementForm
            objDepts={objDepts}
            isEdit={!!user}
            onSubmit={onSubmit}
            isLoading={isSaving}
            deptDropOptions={deptDropOptions}
            user={user}
          />
        </div>
      </div>
    </div>
  );
};

export default withRouter(CrewInviteUserModal);
